export type VideoPreviewProps = {
  thumbnail: string | null;
  media: string | null;
};

export const VIDEO_PREVIEW_DEFAULT = {
  thumbnail: null,
  media: null,
} as VideoPreviewProps;
